module.exports = __webpack_public_path__ + "img/dashbord-interviewrr.b81d18a1.png";